import React from "react"
import {StyledGridContent} from "./components"

const StandardGridContent = ({props, xxlBreakpointEnabled, children}: any) => {
    return (
        <StyledGridContent {...props} xxlBreakpointEnabled={xxlBreakpointEnabled}>
            {children}
        </StyledGridContent>
    )
}

export default StandardGridContent
